// extracted by mini-css-extract-plugin
export default {"Header":"Modal_Header__TDU9q","Body":"Modal_Body__kH3No","Footer":"Modal_Footer__axyPS","FooterButton":"Modal_FooterButton__IKzxH"};